import { useRef, useState } from 'react'

const useSearch = (onSearch, delay = 3000) => {
  const [searchInput, setSearchInput] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const timeoutRef = useRef(null)

  const handleSearchValue = (event) => {
    const value = event.target.value
    setSearchInput(value)
    setIsSearching(true)

    if (timeoutRef.current) clearTimeout(timeoutRef.current)

    timeoutRef.current = setTimeout(() => {
      onSearch(value)
      setIsSearching(false)
    }, delay)
  }

  return { searchInput, handleSearchValue, isSearching }
}

export default useSearch
